import React from "react";
import styled from "styled-components";
import { greyColor } from "./colors";
import { Content } from "./Content";
import { ExternalLink } from "./ExternalLink";
import { desktopQuery, mobileQuery } from "./MediaQuery";
import { ResponsiveLayout } from "./ResponsiveLayout";
import { Separated } from "./Separated";
import analytics from "./services/analytics";
import { SizedBox } from "./SizedBox";
import { language, translation } from "./translations";
import { Paragraph1 } from "./typography";
import { nl2br } from "./utils";
import { NavigationPath } from "./navigation/NavigationCommon";
import { FooterLink } from "./FooterLink";

export const Footer: React.FC = () => {
  return (
    <footer>
      <div style={{ backgroundColor: greyColor }}>
        <Content>
          <ResponsiveLayout
            justifyContent="space-evenly"
            alignItems="center"
            style={{
              padding: 40,
            }}
          >
            <div
              style={{
                color: "white",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <TopLink
                href="https://www.facebook.com/vikalife"
                onClick={() => {
                  analytics.logOpenFacebook();
                }}
              >
                <img src="/home/facebook-white.svg" />
              </TopLink>
              <TopLink
                href="https://www.instagram.com/vika_life_app"
                onClick={() => {
                  analytics.logOpenInstagram();
                }}
              >
                <img src="/home/instagram-white.svg" />
              </TopLink>
              {nl2br(translation.joinCommunity)}
            </div>

            <SizedBox mobileHeight={24} />

            <TopLink
              href="mailto:contact@vika.life"
              onClick={() => {
                analytics.logContact();
              }}
            >
              <img src="/home/mail.svg" />
              {translation.contactUs}
            </TopLink>

            <SizedBox mobileHeight={24} />

            <TopLink href="http://lab4.life">
              {nl2br(translation.companyAddress)}
            </TopLink>
          </ResponsiveLayout>
        </Content>
      </div>
      <FooterCopyright />
      <SizedBox height={16} />
      <FooterSponsors />
      <SizedBox height={24} />
    </footer>
  );
};

export const FooterCopyright: React.FC<{ className?: string }> = (props) => (
  <div className={props.className}>
    <Content>
      <FooterCopyrightWrapper>
        <Separated>
          {translation.copyrightNotice}
          {translation.allRightsReserved}
        </Separated>

        <Separated>
          {translation.privacyPolicy}
          <FooterLink to={NavigationPath.deleteAccount}>
            {translation.deleteAccount}
          </FooterLink>
        </Separated>
      </FooterCopyrightWrapper>
    </Content>
  </div>
);

const FooterSponsors: React.FC = () => (
  <Content>
    <SponsorsInfo>{translation.lifePlusProject}</SponsorsInfo>
    <SizedBox height={16} />
    <SponsorsImage
      src={language === "pl" ? "/lifePlusLogosPl.png" : "/lifePlusLogosEn.png"}
    />
  </Content>
);

const FooterCopyrightWrapper = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  color: ${greyColor};
  font-size: 12px;
  ${mobileQuery`
    flex-direction: column-reverse;
    justify-content: space-evenly;

    > div:last-child {
      margin-bottom: 16px;
    }
  `}
`;

const SponsorsInfo = styled(Paragraph1)`
  text-align: center;

  ${mobileQuery`
    text-align: left;
  `}
`;

const SponsorsImage = styled.img`
  display: block;
  margin: 0 auto;
  padding: 8px 0;
  ${desktopQuery`
    height: 80px;  
  `}
  ${mobileQuery`
    width: 100%;
  `}
`;

const HoverLink = styled(ExternalLink)`
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`;

const TopLink = styled(HoverLink)`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: white;
  text-align: center;

  img {
    margin-right: 8px;
  }
`;
